import { __assign, __spreadArray } from '../node_modules/tslib/tslib.es6.js';
import amazonAds from './amazonAds.js';
import googleTags from './google.js';
import metaPixel from './metaPixel.js';
import tddPixel from './tdd.js';
import { parseEventAndPayload } from './utils.js';

var randomKey = 'd24buQs3x5ag';
var debug = false;
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return debug && 
    // eslint-disable-next-line no-console
    console.info.apply(
    // eslint-disable-next-line no-console
    console, ['[externalTracking]'].concat(args));
};
// Registry of tracking providers
var trackingProviders = {
    Meta: {
        enableDebug: function () { return metaPixel.enableDebug(); },
        track: function (_a) {
            var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
            return metaPixel.track({ brandId: brandId, pixels: pixels, eventName: eventName, eventType: eventType, eventPayload: eventPayload });
        }
    },
    GoogleAds: {
        enableDebug: function () { return googleTags.enableDebug(); },
        track: function (_a) {
            var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
            return googleTags.track({ brandId: brandId, pixels: pixels, eventName: eventName, eventType: eventType, eventPayload: eventPayload });
        }
    },
    TTD: {
        enableDebug: function () { return tddPixel.enableDebug(); },
        track: function (_a) {
            var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
            return tddPixel.track({ brandId: brandId, pixels: pixels, eventName: eventName, eventType: eventType, eventPayload: eventPayload });
        }
    },
    AmazonAds: {
        enableDebug: function () { return amazonAds.enableDebug(); },
        track: function (_a) {
            var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
            return amazonAds.track({ brandId: brandId, pixels: pixels, eventName: eventName, eventType: eventType, eventPayload: eventPayload });
        }
    }
};
/**
 * Register a new tracking provider
 */
function registerTrackingProvider(providerId, provider) {
    trackingProviders[providerId] = provider;
    log("Registered tracking provider: ".concat(providerId));
}
/**
 * Enable debug mode for all providers
 */
function enableDebug() {
    debug = true;
    log('Enabling debug mode');
    Object.values(trackingProviders).forEach(function (provider) { return provider.enableDebug(); });
}
function setIdentity(identity) {
    metaPixel.setIdentity(identity);
}
/**
 * Track an event with all registered providers
 */
function track(event, params, pixelContainer) {
    var _a, _b, _c;
    // Handle debug flag
    if (params === null || params === void 0 ? void 0 : params[randomKey]) {
        enableDebug();
        params[randomKey] = undefined;
    }
    log('track', { event: event, params: params, pixelContainer: pixelContainer });
    if (!(pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.brandId) && !((_a = pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.pixels) === null || _a === void 0 ? void 0 : _a.length)) {
        // check checkoutitems array and if it has length 1 then copy over all the params from the first item
        if (((_b = params === null || params === void 0 ? void 0 : params.checkoutItems) === null || _b === void 0 ? void 0 : _b.length) === 1) {
            var firstItem = params.checkoutItems[0];
            params = __assign(__assign({}, params), { brandId: firstItem.brandId, brandName: firstItem.brandName, categoryId: firstItem.categoryId, categoryName: firstItem.categoryName, subCategoryId: firstItem.subCategoryId, subCategoryName: firstItem.subCategoryName, retailerId: firstItem.retailerId, retailerSku: firstItem.retailerSku, stacklineSku: firstItem.stacklineSku });
            if (firstItem.pixels) {
                pixelContainer = {
                    brandId: firstItem.brandId,
                    pixels: firstItem.pixels,
                };
            }
        }
    }
    // Validate required parameters
    if (!(params === null || params === void 0 ? void 0 : params.v_id) || !(pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.brandId) || !((_c = pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.pixels) === null || _c === void 0 ? void 0 : _c.length)) {
        log('track required missing params', { event: event, params: params, pixelContainer: pixelContainer });
        return;
    }
    // Group pixels by provider for efficient processing
    var pixelsByProvider = pixelContainer.pixels.reduce(function (acc, pixel) {
        var provider = pixel.pixelProvider;
        acc[provider] = __spreadArray(__spreadArray([], (acc[provider] || []), true), [pixel], false);
        return acc;
    }, {});
    // Process each provider
    Object.entries(pixelsByProvider).forEach(function (_a) {
        var provider = _a[0], providerPixels = _a[1];
        var trackingProvider = trackingProviders[provider];
        if (!trackingProvider) {
            log("No provider registered for ".concat(provider));
            return;
        }
        try {
            providerPixels.forEach(function (pixel) {
                var _a = parseEventAndPayload(event, params, pixel.eventMapping), eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
                if (!eventName || !((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.brandId) || (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.stacklineSku) || ((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.checkoutItems) && eventPayload.checkoutItems.length > 0))) {
                    log('track event not supported', event, params, pixelContainer);
                    return;
                }
                trackingProvider.track({
                    brandId: pixelContainer.brandId,
                    pixels: [pixel],
                    eventName: eventName,
                    eventType: eventType,
                    eventPayload: eventPayload
                });
            });
        }
        catch (error) {
            log("Error tracking with provider ".concat(provider, ":"), error);
        }
    });
}

export { enableDebug, registerTrackingProvider, setIdentity, track };
//# sourceMappingURL=externalTracking.js.map
